import { IMAGE_AVAILABILITY_API } from 'constants/AppConstants';

export default async (latitude, longitude) => {
  try {
    const response = await fetch(`${IMAGE_AVAILABILITY_API}?latitude=${latitude}&longitude=${longitude}`);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
